import { app } from '../../../app';

class PoliciesService{

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }


}

app.service('PoliciesService', PoliciesService);


// WEBPACK FOOTER //
// ./src/portal/states/company/policies/policies.services.js